import Assignee from 'models/assignee';
import ConversationUpdater from 'actions/conversation/lib/conversation_updater';
import RoutingItemType from 'models/routing_item_type';
import Communicator from 'models/communicator';

export default class AssignConversation extends ConversationUpdater {
  run(attrs) {
    let conversation = this.context.stores.conversations.find(attrs.conversationId);

    if (isSameAssignee(conversation.assignee, attrs.assignee)) {
      return;
    }

    let newAssignee;
    if (!attrs.assignee.agentId) {
      newAssignee = new Assignee({ routingGroupId: attrs.assignee.routingGroupId, agentId: '' });
    } else {
      newAssignee = new Assignee({ routingGroupId: attrs.assignee.routingGroupId, agentId: attrs.assignee.agentId });
    }

    this.updateConversation(conversation.id, {
      assignee: {
        ...newAssignee,
        routingItemType: RoutingItemType.MANUAL_ASSIGNMENT,
        initiator: {
          id: this.context.stores.currentAgent.get().id,
          type: Communicator.AGENT,
        },
      },
    });
  }
}

function isSameAssignee(assigneeWas, newAssignee) {
  return (
    (!newAssignee.agentId && !assigneeWas.agentId && assigneeWas.routingGroupId === newAssignee.routingGroupId) ||
    (assigneeWas.agentId === newAssignee.agentId && assigneeWas.routingGroupId === newAssignee.routingGroupId)
  );
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/assign_conversation.js